import React from 'react'

const Ambient = () => (
  <>
    <div className="aurora" />
    <div className="grain" />
  </>
)

export default Ambient
